var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3377_4861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3377_4861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6158 16.6539L17.5609 9.7327L15.8663 8.01432L10.6158 13.2411L8.06205 10.6874L6.36754 12.4057L10.6158 16.6539ZM12 22C10.5998 22 9.29515 21.7375 8.08592 21.2124C6.87669 20.6874 5.82275 19.9755 4.9241 19.0768C4.02482 18.1776 3.31265 17.1233 2.78759 15.9141C2.26253 14.7049 2 13.4002 2 12C2 10.5998 2.26253 9.29515 2.78759 8.08592C3.31265 6.87669 4.02482 5.82243 4.9241 4.92315C5.82275 4.0245 6.87669 3.31265 8.08592 2.78759C9.29515 2.26253 10.5998 2 12 2C13.4002 2 14.7049 2.26253 15.9141 2.78759C17.1233 3.31265 18.1776 4.0245 19.0768 4.92315C19.9755 5.82243 20.6874 6.87669 21.2124 8.08592C21.7375 9.29515 22 10.5998 22 12C22 13.4002 21.7375 14.7049 21.2124 15.9141C20.6874 17.1233 19.9755 18.1776 19.0768 19.0768C18.1776 19.9755 17.1233 20.6874 15.9141 21.2124C14.7049 21.7375 13.4002 22 12 22Z",
    fill: "#00855D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.75c44dbc1d22aab409fa32a4078b21ec.svg";
export { ForwardRef as ReactComponent };